var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"id":"Overlay","absolute":true,"value":_vm.status,"opacity":0.7}},[(_vm.loading == true)?_c('div',{staticClass:"Loading"},[_c('v-progress-circular',{staticClass:"mr-5",attrs:{"size":"24","width":"5","indeterminate":"","color":"white"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }